import { useMutation } from '@tanstack/react-query'

import { RenovarTokenService } from '@/features/user/services/renovar-token.service'
import { userKeys } from '@/features/user/utils'

export const useRefreshToken = () => {
  return useMutation({
    mutationKey: userKeys.refresh(),
    mutationFn: async () => new RenovarTokenService().execute(),
  })
}
